import { createIcon } from '@chakra-ui/react';

export const BurnInRefreshIcon = createIcon({
  displayName: 'BurnInRefreshIcon',
  viewBox: '0 0 22 19',
  defaultProps: {
    fill: 'none',
    height: '6',
    width: '6',
  },
  path: (
    <>
      {/* Monitor frame */}
      <path
        d="M5 18H17M21 13V3C21 1.89543 20.1046 1 19 1L3 1C1.89543 1 1 1.89543 1 3L1 13C1 14.1046 1.89543 15 3 15L19 15C20.1046 15 21 14.1046 21 13Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
      {/* Refresh symbol centered inside the screen area, scaled to fit */}
      <g transform="translate(5, 2.5) scale(1)">
        <path
          d="M8 3.8H7.3V5.2H8V4.5V3.8ZM10.7 2.5V1.8H9.3V2.5H10H10.7ZM4 8.2H4.7V6.8H4V7.5V8.2ZM1.3 9.5V10.2H2.7V9.5H2H1.3ZM8 4.5V5.2H9.5V4.5V3.8H8V4.5ZM10 4H10.7V2.5H10H9.3V4H10ZM9.5 4.5V5.2C10.1627 5.2 10.7 4.66274 10.7 4H10H9.3C9.3 3.88954 9.38954 3.8 9.5 3.8V4.5ZM4 7.5V6.8H2.5V7.5V8.2H4V7.5ZM2 8H1.3V9.5H2H2.7V8H2ZM2.5 7.5V6.8C1.83726 6.8 1.3 7.33726 1.3 8H2H2.7C2.7 8.11046 2.61046 8.2 2.5 8.2V7.5ZM10 6H9.3C9.3 7.82254 7.82254 9.3 6 9.3V10V10.7C8.59574 10.7 10.7 8.59574 10.7 6H10ZM2 6H2.7C2.7 4.17746 4.17746 2.7 6 2.7V2V1.3C3.40426 1.3 1.3 3.40426 1.3 6H2ZM6 2V2.7C7.36626 2.7 8.54018 3.53044 9.04145 4.71688L9.68626 4.44444L10.3311 4.17201C9.61856 2.48561 7.94854 1.3 6 1.3V2ZM6 10V9.3C4.63374 9.3 3.45982 8.46956 2.95855 7.28312L2.31374 7.55556L1.66893 7.82799C2.38144 9.51439 4.05146 10.7 6 10.7V10Z"
          fill="currentColor"
        />
      </g>
    </>
  ),
});
